module.exports = __webpack_public_path__ + "img/ex16.07259ac9.png";